/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var DataChartPieA2Icon24Regular = forwardRef('DataChartPieA2Icon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M12 2.25a.75.75 0 0 0-.75.75v9c0 .414.336.75.75.75h9a.75.75 0 0 0 .75-.75A9.75 9.75 0 0 0 12 2.25Zm.75 9V3.784a8.25 8.25 0 0 1 7.466 7.466H12.75Z" }),
        React.createElement("path", { d: "M9.026 4.305a.75.75 0 1 0-.54-1.4A9.75 9.75 0 1 0 21.09 15.524a.75.75 0 0 0-1.399-.542A8.25 8.25 0 1 1 9.026 4.305Z" })));
});
